import { render, staticRenderFns } from "./RolesIndex.vue?vue&type=template&id=1b5e72b1&"
import script from "./RolesIndex.vue?vue&type=script&lang=js&"
export * from "./RolesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports